<template>
  <div class="vchy-filters__mobile-wrapper">
    <slot />

    <button
      class="clear-btn"
      v-if="
        (rangeSelected == null && isFiltersSelected && filterlength >= 1) ||
        (rangeSelected != null && isFiltersSelected && filterlength > 1)
      "
      @click="clearFilters"
    >
      {{ clearBtnTitle }}
    </button>
    <p class="heading-sm uppercase" aria-live="polite">
      {{ totalProducts }}
    </p>

    <vch-modal
      v-if="matchMedia"
      :open="modalOpen"
      @closed="closeModal"
      :closeAriaLabel="closeAriaLabel"
      :busName="busName"
      :modal-heading-aria-label="modalHeadingAriaLabel"
    >
      <h2 class="heading-xl">{{ title }}</h2>
      <vch-product-filters
        v-if="filters.length"
        ref="productfilters"
        :filters="filters"
        :clear-btn-title="clearBtnTitle"
        @range-select="isRangeSelected($event)"
        @filters-selected="onSelectFilter"
      ></vch-product-filters>
      <div class="vchy-filters__control-btn">
        <button
          class="button -primary --small"
          @click="closeModal(), dataTaggingMobile()"
        >
          <div class="snippet" data-title=".dot-pulse" v-if="loading">
            <div class="stage">
              <div class="dot-pulse"></div>
            </div>
          </div>
          <span v-else> {{ resultsBtnTitle }}</span>
        </button>
        <button
          class="clear-btn text-button"
          v-if="
            (rangeSelected == null && isFiltersSelected && filterlength >= 1) ||
            (rangeSelected != null && isFiltersSelected && filterlength > 1)
          "
          @click="clearFilters"
        >
          {{ clearBtnTitle }}
        </button>
      </div>
    </vch-modal>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'vch-product-filters-mobile',
  props: {
    closeAriaLabel: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      default: 'FILTER PRODUCTS',
    },
    filters: {
      type: String,
      required: true,
    },
    totalProductCount: {
      type: String,
    },
    clearBtnTitle: {
      type: String,
      required: true,
    },
    resultsBtnTitle: {
      type: String,
      required: false,
    },
    singleProduct: {
      type: String,
      required: false,
    },
    multipleProducts: {
      type: String,
      required: false,
    },
    modalHeadingAriaLabel:{
      type: String,
      required: false,
      default: 'Modal heading',
    },
  },
  data() {
    return {
      busName: 'product-filters-modal',
      modalOpen: false,
      isFiltersSelected: false,
      loading: false,
      busFilterName: 'item-grid',
      total: null,
      matchMedia: null,
      rangeSelected: null,
      filterlength: 0,
      selectedValues: [],
      selectedValuesString: '',
    };
  },
  computed: {
    totalProducts() {
      const text =
        Number(this.total) > 1 ? this.multipleProducts : this.singleProduct;
      return `${this.total} ${text}`;
    },
  },
  mounted() {
    this.matchMedia = window.matchMedia('(max-width: 1024px)').matches;
    this.total = this.totalProductCount;
    eventBus.$on(`${this.busName}:open`, this.openModal);
    eventBus.$on(`${this.busFilterName}:filters-selected`, this.selectFilter);
    eventBus.$on(`${this.busFilterName}:loadingState`, this.setLoading);
    eventBus.$on(
      `${this.busFilterName}:total-filters-result`,
      this.totalFiltersResults
    );
    eventBus.$on(`${this.busFilterName}:filters`, this.onSelectFilter);
  },
  methods: {
    closeModal() {      
      this.modalOpen = false;
      eventBus.$emit(`${this.busName}:filters-selected`);      
    },
    openModal() {
      this.modalOpen = true;
    },
    selectFilter() {
      this.isFiltersSelected = true;
    },
    clearFilters() {
      this.isFiltersSelected = false;
      eventBus.$emit(`${this.busFilterName}:clearFilters`,this.modalOpen);
    },
    setLoading(state) {
      this.loading = state;
    },
    totalFiltersResults(total) {
      this.total = total;
    },
    onSelectFilter(data) {
      this.filterlength = data.length;
      if(this.filterlength > 0){
        this.isFiltersSelected = true;
      }
    },
    isRangeSelected($event) {
      this.rangeSelected = $event;
    },
    updateSelectedValues() {
      this.selectedValues = [];
      this.selectedValuesString = '';
      let checkboxesgroup = document.querySelectorAll(
        '.vchy-filters__mobile-wrapper .vchy-filters__wrapper div[role="group"]'
      );
      checkboxesgroup.forEach((item) => {
        let checkboxItem = item.querySelectorAll('input[type="checkbox"]');

        checkboxItem.forEach((checkboxitem) => {
          if (checkboxitem.checked) {
            let vchyDetails = checkboxitem.closest('.vchy-details');

            if (vchyDetails) {
              let summarySpan = vchyDetails.querySelector('summary span');
              if (summarySpan) {
                var spanValue = summarySpan.textContent;
                if (!this.selectedValues.includes(spanValue)) {
                  this.selectedValues.push(spanValue);
                }
              }
            }
            this.selectedValues.push(checkboxitem.name);
          }
        });
      });
      this.selectedValuesString = this.selectedValues.join('::');
    },

    dataTaggingMobile() {
      this.$refs.productfilters.viewResult();
      this.updateSelectedValues();
      pushEvent({
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'product selector page',
        eventAction: 'filter',
        eventLabel: this.selectedValuesString
          ? this.selectedValuesString.toLowerCase()
          : '',
        event_name: 'use_filters',
        filter_type: 'filter',
        filter_value: this.selectedValuesString
          ? this.selectedValuesString.toLowerCase()
          : '',
      });
    },
  },
};
</script>
<style lang="scss" src="./product-filters-mobile.scss"></style>
